export default __webpack_public_path__ + "static/media/hydra_image_black_background.21e07d48.png";